import { memo } from 'react';

const fmtEUR = (n: number | null | undefined) =>
  n == null || isNaN(n)
    ? '—'
    : n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const MekCell = memo(function MekCell({ value }: { value: number | null }) {
  return (
    <span style={{ width: '100%', textAlign: 'right', display: 'block' }}>
      {fmtEUR(value)}
    </span>
  );
});
